<template>
  <v-card style="height: 400px" class="scrollable-card" :loading="loading">
    <v-card-title class="pb-0">
      Attendance
      <v-icon class="ml-1" @click="getItems()">mdi-refresh</v-icon>
      <v-spacer></v-spacer>

      <!-- target="_blank" -->
      <router-link :to="'/attendance-slip/my-requests'" >
        <v-icon class="pointer" v-tooltip="'Open submitted requests in a new tab'">
          open_in_new
        </v-icon>
      </router-link>
    </v-card-title>

    <v-simple-table style="width: 100%" height="320px" dense fixed-header>
      <template v-slot:default>
        <thead>
          <tr class="text-uppercase">
            <th width="10px">Duty Date</th>
            <th>First In</th>
            <th>Worked</th>
            <th class="text-center">Work</th>
            <th class="text-center">Break</th>
            <th class="1px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td>
              <div>{{ $localeDate(item.duty_date) }}</div>
              <div>
                <v-chip x-small class="text-uppercase white--text" :color="item.status == 'Absent' ? 'red' : 'blue'">{{ item.status }}</v-chip>
              </div>
            </td>
            <td>
              <span v-if="item.firstIn">
                {{ $localeDateTime(item.firstIn.dtATIN).split(',').pop() }}
              </span>
            </td>
            <td>
              <span v-if="item.staff_day && item.staff_day.worked_hours">
                {{ item.staff_day.worked_hours }}
              </span>
            </td>
            <td>
              <!-- title="Work" -->
              <PercentChart
                class="my-1"
                v-if="item.staff_day && item.staff_day.percent_work"
                height="35"
                :percent="item.staff_day.percent_work"
                mainColor="#4c4"
                accentColor="#afa"
                :percent_label_size="12"
              ></PercentChart>
            </td>
            <td>
              <!-- title="Break" -->
              <PercentChart
                class="my-1"
                v-if="item.staff_day && item.staff_day.percent_break"
                height="35"
                :percent="item.staff_day.percent_break"
                mainColor="#dd2"
                accentColor="#ff9"
                :percent_label_size="12"
              ></PercentChart>
            </td>
            <td class="text-right">
              <v-icon v-if="item.appliable" @click="$refs.slipModal.open(item.duty_date, null)" v-tooltip="'request attendance'">
                mdi-open-in-new
              </v-icon>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <!-- modal -->
    <slip-modal ref="slipModal"></slip-modal>
  </v-card>
</template>

<script>
import swal from 'sweetalert'
import SlipModal from './SlipModal.vue'
import PercentChart from '../charts/am5PercentChart.vue'

export default {
  name: 'attendance-requests',
  components: { SlipModal, PercentChart },
  data: () => ({
    items: null,
    loading: false,
    totalPages: 0,
    requestParams: { page: 1, limit: 15 },
    types: [],
    AttModels: true,
  }),

  methods: {
    deleteLeaveRequest(id) {
      swal({
        title: 'Are you sure?',
        text: 'Once deleted, you will not be able to recover this request!',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(value => {
        if (value) {
          this.loading = true
          this.$axios
            .delete(`/api/leave-request/deleteLeave/${id}`)
            .then(resp => {
              // do something
              this.getItems()
            })
            .finally(() => (this.loading = false))
        }
      })
    },

    getItems() {
      this.loading = true
      this.$axios
        // .get(`/api/attendance-slips/staff-day`, { params: this.requestParams })
        .get(`/api/attendance-slips/getPayrollAttendance`, { params: { limit: 5 } })
        .then(resp => {
          this.items = resp.data
          this.loading = false
        })
    },
  },

  mounted() {
    this.getItems()
  },
}
</script>
/
<style >
.scrollable-card {
  height: 400px;
}
.scrollable-card {
  scrollbar-width: thin !important;
  scrollbar-color: auto !important;

  overflow-y: auto;
  padding-right: 16px;
}
</style>